export default {
  UPDATE_PROMO (state, promo) {
    state.activePromo = promo
  }
}
